const state = {
  filters: {},
  tableData: [],
  isEmpty: true
};

export default {
  state
};
